import { createAsyncThunk } from '@reduxjs/toolkit'
import { getDealerAssignedLinks } from 'api/flexLinks'

const loadFlexLinks = createAsyncThunk('dealership/loadFlexLinks', async () => {
    return getDealerAssignedLinks()
})

export default loadFlexLinks
